module.exports = __webpack_public_path__ + "static/media/nynfc12.b6f5dd3c.jpg";